import posthog from "posthog-js";

export function trackEvent(name, props = {}) {
  if (process.env.REACT_APP_POSTHOG_KEY && posthog) {
    posthog.capture(name, props);
  }
}
